import { render, staticRenderFns } from "./BaseModalButton.vue?vue&type=template&id=55c56d1e&scoped=true&"
import script from "./BaseModalButton.vue?vue&type=script&lang=js&"
export * from "./BaseModalButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalButton.vue?vue&type=style&index=0&id=55c56d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c56d1e",
  null
  
)

export default component.exports